import { render, staticRenderFns } from "./dictionaryGroupList.vue?vue&type=template&id=3cb5ab04&scoped=true&"
import script from "./dictionaryGroupList.vue?vue&type=script&lang=js&"
export * from "./dictionaryGroupList.vue?vue&type=script&lang=js&"
import style0 from "./dictionaryGroupList.vue?vue&type=style&index=0&id=3cb5ab04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb5ab04",
  null
  
)

export default component.exports